import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import { ActionButton, css, TooltipHost, TooltipOverflowMode, mergeStyleSets, IconButton } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { CColorPicker } from './CColorPicker';
import { deleteBoardElement } from '../../../../../services/sKPI/board.service';
import NoDataLayer from '../../../../Common/NoDataLayer';
import MessageBox from '../../../../Common/Message/MessageBox';
import { __MessageTypes } from '../../../../../common/Dictionaries';
import { canEditBoardOrGapByElement, showMessage } from '../../../../../common/Helpers';
import PropTypes from 'prop-types';
import './style-card.css'
import './style-color-picker.css'
import { useContext } from 'react';
import MainAppContext from '../../../../../MainAppContext';
import BoardAppContext from '../../../../../BoardAppContext';
import { useGetBoardElementsByBoardIdAndElementId } from '../../../../../hooks/services/sKPI/useOfBoard';
function BoardElementSelected(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);

    //Parametros de entrada.
    const { 
        inputParam_EditMode = false,
        inputParam_ElementItem = null,
        inputParam_TextIsDataLang = false,
        inputParam_BoardId = null,
        inputParam_SetterBoardElementDeleted = null,
        inputParam_SetterBoardElementColor = null,
        inputParam_SetterStatusFly = null,
        inputParam_ListElementColors = [],
        inputParam_BoardElementDataserieUnsavedList = null,
        inputParam_SetBoardElementDataserieUnsavedList = null,
        inputParam_RoleList = null,
        inputParam_ElementList = null,
        inputParam_SetBoardElements = null,
        inputParam_SetStatusFly = null
    } = props;
    
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const [fireGet, setFireGet] = useState(false);
    useGetBoardElementsByBoardIdAndElementId(inputParam_BoardId, inputParam_ElementItem.elementId, inputParam_ElementList, inputParam_SetBoardElements, fireGet, setFireGet)

    const onDeleteBoardElement = (e, id) => {
        deleteBoardElement(inputParam_ElementItem.id).then((response) => {
            if (response.data.succeeded) {
                showMessage(setMessageConfig, false, null, null)

                for (var i = inputParam_BoardElementDataserieUnsavedList.length - 1; i >= 0; --i) {
                    let itemExist = inputParam_ElementItem.l_variables.find(x => x.boardElementId === inputParam_BoardElementDataserieUnsavedList[i].boardElementId && x.dataserieId === inputParam_BoardElementDataserieUnsavedList[i].dataserieId)
                    
                    if (itemExist) {
                        inputParam_BoardElementDataserieUnsavedList.splice(i,1);
                    }
                }

                inputParam_SetBoardElementDataserieUnsavedList && inputParam_SetBoardElementDataserieUnsavedList(inputParam_BoardElementDataserieUnsavedList);

                inputParam_SetterBoardElementDeleted && inputParam_SetterBoardElementDeleted(inputParam_ElementItem.id);
                inputParam_SetterStatusFly && inputParam_SetterStatusFly(prevState => ({
                    fireUpdate: true,
                }))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch((error) => {
            let message = null

            if (!error.response) {
                message = t('data-lang-msg-networkerror')
            } else {
                message = t('data-lang-msg-operationerror')
            }

            showMessage(setMessageConfig, true, __MessageTypes.ERROR, message)
        })
    };

    const onRefreshCallElement = () =>{
        setFireGet(true)
        inputParam_SetStatusFly && inputParam_SetStatusFly(prevState => ({
            fireUpdate: true
        }));
    }

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });

    return (
        <div className='h-100 rounded' style={{border: `${inputParam_ElementItem._isValidElement === true ? '' : '1px solid red'}`}}>
            <Card className='h-100' style={{ fontSize: "13px", borderLeft: `20px solid ${ inputParam_ElementItem.htmlColor !== null && inputParam_ElementItem.htmlColor !== undefined ? inputParam_ElementItem.htmlColor : "" }` }}>
                <Card.Header className="card-header-full">
                    <Card.Title className="d-flex justify-content-between">
                        <b>
                            <TooltipHost
                                overflowMode={TooltipOverflowMode.Self}
                                hostClassName={css(classNames.overflow)}
                                content={ inputParam_TextIsDataLang ? t(inputParam_ElementItem.elementName) : inputParam_ElementItem.elementName }
                                onTooltipToggle={false}
                                styles={{
                                    root: { display: 'block', height: "30px" },
                                }}
                            >
                                { inputParam_TextIsDataLang ? t(inputParam_ElementItem.elementName) : inputParam_ElementItem.elementName }
                            </TooltipHost>
                            <div style={{ fontSize: "13px", paddingTop: "-5px"}}>
                                {inputParam_ElementItem.elementCode}
                            </div>
                        </b>
                        {
                            inputParam_ElementItem._isValidElement === false &&
                            <IconButton styles={ {icon: {color: "red", fontSize: "20px"}}} iconProps={{ iconName: 'AlertSolid' }} title={t('data-lang-msg-uploadrolesvariablescolor')} />
                        }
                        {
                            inputParam_ElementItem._isValidElement === true &&
                            <IconButton styles={ {icon: {color: "green", fontSize: "20px"}}} iconProps={{ iconName: 'SkypeCircleCheck' }} title={t('data-lang-msg-elementvalidated')} />
                        }
                    </Card.Title>

                </Card.Header>
                <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar d-flex float-end'>
                        {
                            inputParam_EditMode && (contextSite.securityProps.isAdmin || canEditBoardOrGapByElement(contextBoard.userPropsKpi.value, inputParam_ElementItem.id)) &&
                            <>
                                <ActionButton iconProps={{ iconName: 'Refresh' }} onClick={ onRefreshCallElement }>
                                    { t('data-lang-btn-refresh') }
                                </ActionButton>
                                <ActionButton iconProps={{ iconName: 'BackgroundColor' }} styles={{label:{whiteSpace : "nowrap"}}} onClick={ toggleHideDialog }>
                                    { t('data-lang-btn-selectcolor') }
                                </ActionButton>
                                <ActionButton iconProps={{ iconName: 'Delete' }} onClick={ onDeleteBoardElement }>
                                    { t('data-lang-btn-delete') }
                                </ActionButton>
                            </>
                        }
                    </div>
                </Card.Footer>
                <Card.Body className="card-board p-2">
                    <Row>
                        <Col xl={12} className="card-board-body">
                            <h6><b>{ t('data-lang-lbl-variables') }</b></h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} className="card-board-body ps-4">
                            {
                                inputParam_ElementItem.l_variables && 
                                <>
                                    <Row>
                                        <Col><b>{t('data-lang-lbl-name')}</b></Col>
                                        <Col><b>{t('data-lang-lbl-measurementunit')}</b></Col>
                                    </Row>
                                    {
                                        inputParam_ElementItem.l_variables.map((item, index) => (
                                            <Row key={index}>
                                                <Col>{item.variableName}</Col>
                                                <Col>{item.variableUM}</Col>
                                            </Row>
                                        ))
                                    }
                                </>
                            }
                            
                            <NoDataLayer display={inputParam_ElementItem.l_variables && inputParam_ElementItem.l_variables.length === 0}/>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Body className="card-board p-2">
                    <Row>
                        <Col xl={12} className="card-board-body">
                            <h6><b>{ t('data-lang-lbl-permissions') }</b></h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} className="card-board-body ps-4">
                            {
                                inputParam_RoleList && inputParam_ElementItem.l_roles.length > 0 && 
                                <>
                                    <Row>
                                        <Col><b>{t('data-lang-lbl-name')}</b></Col>
                                        <Col><b>{t('data-lang-lbl-type')}</b></Col>
                                    </Row>
                                    {
                                        inputParam_ElementItem.l_roles.map((item, index) => (
                                            <Row key={index}>
                                                <Col>{item.username}</Col>
                                                <Col>{ t(inputParam_RoleList.find(x => x.id === item.privilegeRoleId).name) }</Col>
                                            </Row>
                                        ))
                                    }
                                </>
                            }
                            <NoDataLayer display={inputParam_ElementItem.l_roles && inputParam_ElementItem.l_roles.length === 0}/>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <MessageBox 
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>

                <CColorPicker
                    inputParam_SetterStatusFly={inputParam_SetterStatusFly}
                    inputParam_ToggleHideDialog={toggleHideDialog}
                    inputParam_HideDialog={hideDialog}
                    inputParam_SetterColor={inputParam_SetterBoardElementColor}
                    inputParam_ElementItem={inputParam_ElementItem}
                    inputParam_UnselectableColors={inputParam_ListElementColors}
                    inputParam_SetBoardElements={inputParam_SetBoardElements}
                    inputParam_BoardElements={inputParam_ElementList}
                />
            </Card>
        </div>
    );
}

BoardElementSelected.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ElementItem: PropTypes.object.isRequired,
    inputParam_TextIsDataLang: PropTypes.bool.isRequired,
    inputParam_BoardId: PropTypes.string.isRequired,
    inputParam_SetterBoardElementDeleted: PropTypes.func.isRequired,
    inputParam_SetterBoardElementColor: PropTypes.func.isRequired,
    inputParam_SetterStatusFly: PropTypes.func.isRequired,
    inputParam_ListElementColors: PropTypes.array.isRequired,

    inputParam_BoardElementDataserieUnsavedList: PropTypes.array.isRequired,
    inputParam_SetBoardElementDataserieUnsavedList: PropTypes.func.isRequired,

    inputParam_ElementList: PropTypes.array.isRequired,
    inputParam_SetBoardElements: PropTypes.func.isRequired,

    
    inputParam_RoleList: PropTypes.array.isRequired,
};

export default BoardElementSelected;